/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as o}from"../../../../webgl/Uniform.js";class r extends o{constructor(o,r){super(o,"bool",0,(s,e)=>s.setUniform1b(o,r(e)))}}export{r as BooleanBindUniform};
